<script>
  import Service from '../../../../domain/historico-alteracoes/services'
  import UPagination from '../../../_default/components/Uloc/Pagination'
  import { debounce } from 'lodash'
  import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
  import DetalhesLogAlteracao from './DetalhesLogAlteracao'
  import DataFiltroSelect from '../../grvs/components/grv-lista/DataFiltroSelect'

export default {
    components: {
      DataFiltroSelect,
      DetalhesLogAlteracao,
      UPagination,
      PopupViewer
    },
    name: 'HistoricoAlteracoes',
    data () {
      return {
        isLoading: false,
        data: null,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        filtros: {
          busca: '',
          data: null,
          data1: '',
          data2: ''
        },
        prevent: {},
        showDetalhes: false,
        logSelecionado: null
      }
    },
    computed: {
      filteredData () {
        return this.data || []
      },
      noData () {
        return this.data !== null && this.data.length === 0
      }
    },
    mounted () {
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    methods: {
      reloadData (dates = {}) {
        if (this.filtros.data === 'Periodo') {
          const {data1, data2} = dates
          if (!data1 || !data2) return
          this.filtros.data1 = data1
          this.filtros.data2 = data2
        } else {
          this.filtros.data1 = ''
          this.filtros.data2 = ''
        }
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },

      loadData (limit, page, filtros, force) {
        this.data = null
        this.isLoading = true
        const pageNumber = this.$route.query.page
        if (pageNumber != null && typeof force === 'undefined') page = pageNumber
        Service.lista(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.data = response.data.result
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch(() => {
            this.isLoading = false
          })
      },

      changePage (page) {
        this.pagination.atualPage = page
        this.$router.push({name: 'historico.alteracoes', query: {page: page}})
        this.loadData(this.pagination.limit, page, this.montaFiltros(), true)
      },

      montaFiltros () {
        let mount = ''
        for (const key in this.filtros) {
          if (Object.prototype.hasOwnProperty.call(this.filtros, key)) {
            const val = this.filtros[key]
            if (val !== null && val !== '') {
              mount += `&${key}=${val}`
            }
          }
        }
        return mount
      },

      pesquisar: debounce(function () {
        const busca = this.filtros.busca
        if (this.prevent.busca === busca) return
        this.prevent.busca = busca
        this.pagination.atualPage = 1
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),

      openDetalhes (log) {
        this.logSelecionado = log
        this.showDetalhes = true
      },

      closeDetalhes () {
        this.logSelecionado = null
        this.showDetalhes = false
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Histórico de alterações dos usuários do sistema <span class="badge">{{pagination.totalItems}}</span>
                  </h1>
                  <small class="text-muted">
                    <!--<ordenar-arrematante></ordenar-leilao>-->
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">
                  </div>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-md-6">
                  <data-filtro-select @change="reloadData" v-model="filtros.data" label="Filtrar por data"></data-filtro-select>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label class="title_filter">Pesquisar</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="filtros.busca" @keyup="pesquisar"
                             placeholder="Usuário, descrição, operação...">
                      <span class="input-group-btn">
                        <button class="btn btn-default" type="button" @click="pesquisar">Buscar</button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th>Data</th>
                    <th>Usuário</th>
                    <th>Descrição</th>
                    <th>Entidade alterada</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="100px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                  </tr>
                  <tr v-for="log in filteredData" style="cursor: pointer" @click="openDetalhes(log)">
                    <td class="v-middle">{{ moment(log.data.date).format('DD/MM/YYYY HH:mm:ss')}}</td>
                    <td :class="`v-middle ${!log.username && 'text-center'}`" role="button" tabindex="0" >{{ log.username || '-' }}</td>
                    <td class="v-middle" role="button" tabindex="0">{{ log.descricao }}</td>
                    <td class="v-middle" role="button" tabindex="0">{{ log.entidade }}</td>
                  </tr>

                  <tr v-if="!filteredData || filteredData.length === 0">
                    <td colspan="6">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-2 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{ pagination.totalPages }} </small>
                  </div>
                  <div class="col-sm-6 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage" :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>
      <popup-viewer v-if="showDetalhes" @close="closeDetalhes" :title="`Detalhes do log #${logSelecionado.id}`">
        <detalhes-log-alteracao :log-selecionado="logSelecionado"></detalhes-log-alteracao>
      </popup-viewer>
    </div>
  </transition>
</template>




// WEBPACK FOOTER //
// HistoricoAlteracoes.vue?144b4fc6